export const iconFontAwesomeAnimalsOtter = (
	<i className="fa-solid fa-otter"></i>
);
